import type { ActivityType } from "@torre/work-hours";

// ---------------------------------------------------------------------------
// Etiqueta del tipo de una entrada (#1306). Desde #1300 el `kind` es una clave
// del catálogo de actividades de la compañía, así que la etiqueta sale de ahí
// (en el idioma activo); los tipos base siguen teniendo su texto en i18n por si
// el catálogo aún no cargó, y en último caso se muestra la clave tal cual.
// ---------------------------------------------------------------------------

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** Nombre de un tipo del catálogo en el idioma activo (`nameEn` solo si existe). */
export function activityTypeName(type: Pick<ActivityType, "name" | "nameEn">, language: string | undefined): string {
  const en = String(language ?? "").toLowerCase().startsWith("en");
  return en && type.nameEn ? type.nameEn : type.name;
}

/**
 * Etiqueta de un `kind`: catálogo → i18n (`workHours.timeEntries.kinds.<k>`) → clave.
 * `catalog` puede venir vacío o `null` mientras carga.
 */
export function kindLabel(kind: string | null | undefined, catalog: readonly ActivityType[] | null | undefined, t: Translate, language?: string): string {
  const key = String(kind ?? "").trim();
  if (!key) return "";
  const type = (catalog ?? []).find((x) => x.key === key);
  if (type) return activityTypeName(type, language);
  // `defaultValue` evita que i18next devuelva la clave larga cuando falta la traducción.
  return t(`workHours.timeEntries.kinds.${key}`, { defaultValue: key });
}
